import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-campanha',
    templateUrl: './usuario-permissao-campanha.component.html',
    styleUrls: ['./usuario-permissao-campanha.component.less']
})
export class UsuarioPermissaoCampanhaComponent {
    @Input() entity: Usuario;

    /** Verifica se possui alguma opção para selecionar */
    possuiAlgumaOpcao(): boolean {
        return true;
    }
}
